import script from "./RelatorioAtividadeExecucaoForm_10.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatorioAtividadeExecucaoForm_10.vue?vue&type=script&setup=true&lang=js"

import "./RelatorioAtividadeExecucaoForm_10.vue?vue&type=style&index=0&id=5edb3ac2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5edb3ac2"]])

export default __exports__